import React from 'react';
import dayjs from 'dayjs';
import {
  CalendarDaysIcon,
  BuildingStorefrontIcon,
  BuildingOffice2Icon,
} from '@heroicons/react/24/outline';
import { TWSelect, TWDateRangePicker } from '../../../components/ui';
import { isEmptyObject } from '../../../utils/isEmptyObject';

const DashboardFilters = ({
  isAdmin,
  dateOptions,
  selectedDateRange,
  setSelectedDateRange,
  isShowCustomRange,
  search,
  onDateChange,
  onDateRangeSelectChange,
  companyList,
  globalCompany,
  setGlobalCompany,
  setSearch,
  storeList,
  onSelectStore,
}) => {
  const handleDateSelect = (value) => {
    const next = value || 'weekToD‌​ate';
    onDateRangeSelectChange(next);
    setSelectedDateRange(next);
  };

  const handleCompanySelect = (_, option) => {
    setSearch((prev) => ({ ...prev, storeids: [] }));
    setGlobalCompany(
      _
        ? { name: option.label, id: option.value }
        : { name: 'All Companies', id: null },
    );
  };

  return (
    <div
      className={`grid grid-cols-2 gap-3 sm:gap-4 ${
        isAdmin ? 'md:grid-cols-3' : 'md:grid-cols-2'
      }`}
    >
      <div className={isAdmin ? 'col-span-2 md:col-span-1' : ''}>
        <TWSelect
          label="Date Range"
          labelIcon={CalendarDaysIcon}
          placeholder="Date Range"
          value={selectedDateRange}
          onChange={handleDateSelect}
          options={dateOptions.map((a) => ({
            label: a.label,
            value: a.value,
          }))}
        />
        {isShowCustomRange && (
          <div className="mt-3">
            <TWDateRangePicker
              label="Custom Range"
              labelIcon={CalendarDaysIcon}
              value={[
                search.startdate ? dayjs(search.startdate, 'YYYY-MM-DD') : null,
                search.enddate ? dayjs(search.enddate, 'YYYY-MM-DD') : null,
              ]}
              onChange={(e) => {
                if (e) onDateChange(e);
                else handleDateSelect('weekToD‌​ate');
              }}
            />
          </div>
        )}
      </div>

      {isAdmin && (
        <TWSelect
          label="Company"
          labelIcon={BuildingOffice2Icon}
          placeholder="Company"
          onChange={handleCompanySelect}
          options={[
            { label: 'All Companies', value: null },
            ...companyList.map((a) => ({ label: a.name, value: a.id })),
          ]}
          value={
            isEmptyObject(globalCompany)
              ? null
              : { label: globalCompany?.name, value: globalCompany?.id }
          }
        />
      )}

      <TWSelect
        label="Stores"
        labelIcon={BuildingStorefrontIcon}
        disabled={!globalCompany.id}
        placeholder="All Stores"
        allowClear={false}
        onChange={(v) => onSelectStore(v && v !== 'all' ? v : null)}
        options={[
          { label: 'All Stores', value: 'all' },
          ...storeList.map((a) => ({ label: a.name, value: a.id })),
        ]}
        value={search.storeids?.length > 0 ? search.storeids[0] : 'all'}
      />
    </div>
  );
};

export default DashboardFilters;
